export default __webpack_public_path__ + "static/media/Topaz_partment_8.631a7766.jpg";